import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../../context/FeatureFlagContext';

/**
 * Guards a route based on feature flags.
 * Redirects to home page if the required feature is disabled.
 */
const FeatureGuard = ({ feature, children, fallbackPath = '/' }) => {
  const flags = useFeatureFlags();

  // Wait for flags to load
  if (!flags.loaded) {
    return null; // Or a loading spinner
  }

  // Check if the feature is enabled
  const isEnabled = flags[feature];

  if (!isEnabled) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default FeatureGuard;
